import * as typeform from '@typeform/embed-react';
import { AccountData } from '@types';
import { patch } from '@/utils/api';
import { alertErrorMessage } from '@/utils/alerts';
import { useMemo } from 'react';
import { IUserContext, useUserContext } from '@/context/UserContext';
import { getUserFullName } from '@/components/UserList/utils';
import useAccountData from '@/hooks/useAccountData';
import { mutate } from 'swr';

const { PopupButton } = typeform;

// eslint-disable-next-line  @typescript-eslint/no-unsafe-assignment
const FORM_ID: string = (import.meta.env || process.env)
  ?.VITE_TYPEFORM_CHURN_NOTICE;

export function ChurnNoticeButton({ clientData }: { clientData: AccountData }) {
  const { auth }: IUserContext = useUserContext();
  const { refreshAccountData } = useAccountData();
  const getHiddenProps = useMemo<Record<string, string>>((): Record<
    string,
    string
  > => {
    const userFullName = auth?.id ? getUserFullName(auth) : '';
    const companyName = (clientData.business_info.company_name as string) || '';

    return {
      company_name: companyName || '',
      user_name: userFullName,
      role: 'Internal',
    };
  }, [clientData, auth]);

  const onSubmit = async () => {
    try {
      const result = await patch<string>('clients/churnRiskSubmitted', {
        id: clientData.id,
      });
      await refreshAccountData(clientData.id);
      const accountListAPIUrl = 'account/list';
      await mutate(accountListAPIUrl);
      return result;
    } catch (err) {
      alertErrorMessage(
        `There was an error saving the Churn Notice. Try again or contact the system administrator.`
      );
      return '';
    }
  };

  return (
    <div className='my-3 flex items-center mb-4'>
      <PopupButton
        id={FORM_ID}
        hidden={getHiddenProps}
        transitiveSearchParams={['']}
        className='btn btn-accent btn-sm'
        key='churn_notice-button'
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onSubmit={onSubmit}
      >
        Churn Notice
      </PopupButton>
    </div>
  );
}
